import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';

import { eventTypes, trackEvent } from '../helpers/AnalyticsManager';
import BorderedButton from '../common/borderedButton/BorderedButton';
import VoxarLogo from '../images/logo-voxar-footer.png';
import CInLogo from '../images/logo-cin-footer.png';
import CInLogoWhite from '../images/logo-cin-footer-white.png';
import Separator from '../images/home/separator.png';
import './Footer.css';

class Footer extends Component {
  constructor() {
    super();
    this.beforeAction = this.beforeAction.bind(this);
  }

  beforeAction() {
    const { target } = this.props;

    let event;
    if (target === 'industry') {
      event = eventTypes.footerContact;
    } else {
      event = eventTypes.footerPortfolio;
    }
    trackEvent(event);
    return true;
  }

  render() {
    const { target, whiteMode } = this.props;

    const callToActionTitle = { top: '', bottom: '' };
    const callToActionButton = { title: '', redirect: '' };

    if (target === 'industry') {
      callToActionTitle.top = 'Got a project';
      callToActionTitle.bottom = 'in mind?';
      callToActionButton.title = 'CONTACT';
      callToActionButton.redirect = 'contact';
    } else if (target === 'projects') {
      callToActionTitle.top = 'See our';
      callToActionTitle.bottom = 'projects';
      callToActionButton.title = 'PROJECTS';
      callToActionButton.redirect = 'portfolio';
    }

    let footerClasses = 'Footer';
    if (!whiteMode) {
      footerClasses += ' dark';
    }

    return (
      <div className={footerClasses}>
        { !whiteMode
          && (
          <div className="backgroundPolygon">
            <div className="backgroundPolygonBlue" />
            <div className="backgroundPolygonBlack" />
          </div>
          )
        }
        <div className="ContactSection">
          <div className="CallToAction">
            <h1 className="CallToActionTitle">
              {callToActionTitle.top}
              <br />
              {callToActionTitle.bottom}
            </h1>

            <BorderedButton
              title={callToActionButton.title}
              redirect={`/${callToActionButton.redirect}`}
              darkMonoMode={!whiteMode}
              beforeAction={this.beforeAction}
            />

          </div>
          <div className="AddressSection">
            <MediaQuery query="(max-width: 425px)">
              {(isMobile) => {
                const logo = isMobile ? CInLogoWhite : CInLogo;
                return (
                  <a href="http://cin.ufpe.br" target="_blank" rel="noopener noreferrer">
                    <img src={logo} alt="Informatics Center logo" className="CInLogo" />
                  </a>
                );
              }}
            </MediaQuery>
            <p className="Address">
              Av. Jornalista Anibal Fernandes, s/n
              <br />
              Informatics Center of UFPE
              <br />
              Cidade Universitária (Campus Recife)
              <br />
              50740-560
              <br />
              Recife, PE - Brazil
            </p>
            <p className="ContactInfo">
              <strong>+55 (81) 2126-8430 ext. 4235</strong>
              <br />
              <strong>voxarlabs@cin.ufpe.br</strong>
              <br />
            </p>
          </div>
        </div>
        <div className="SocialMediaSection">
          <div className="copyright">
            <img src={VoxarLogo} alt="Voxar labs logo" className="VoxarLogo" />
            <p>© 2019 Voxar Labs.</p>
          </div>
          <a className="SocialMediaLink" target="_blank" rel="noopener noreferrer" href="https://youtube.com/voxarlabs">YOUTUBE</a>
          <MediaQuery query="(min-width: 425px)">
            <img src={Separator} alt="blue star separator" className="Separator" />
          </MediaQuery>
          <a className="SocialMediaLink" target="_blank" rel="noopener noreferrer" href="https://instagram.com/voxarlabs">INSTAGRAM</a>
          <MediaQuery query="(min-width: 425px)">
            <img src={Separator} alt="blue star separator" className="Separator" />
          </MediaQuery>
          <a className="SocialMediaLink" target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/company/voxarlabs/">LINKEDIN</a>
        </div>
      </div>
    );
  }
}

Footer.propTypes = {
  target: PropTypes.string.isRequired,
  whiteMode: PropTypes.bool,
};

Footer.defaultProps = {
  whiteMode: false,
};

export default Footer;
